import HTML from '../../Assets/html.png';
import CSS from '../../Assets/css.png';
import javascript from '../../Assets/javascript.png';
import react from '../../Assets/react.png';
import redux from '../../Assets/redux.png';
import node from '../../Assets/node.png';
import mongo from '../../Assets/mongo.png';
import firebase from '../../Assets/firebase.png';
import mysql from '../../Assets/mysql2.png';
import aws from '../../Assets/aws.png';
import tailwind from '../../Assets/tailwind.png';
import github from '../../Assets/github.png';


const SkillData = [
    {
        name: 'HTML',
        image: HTML
    },
    {
        name: 'CSS',
        image: CSS
    },
    {
        name: 'TAILWIND CSS',
        image: tailwind
    },
    {
        name: 'JAVASCRIPT',
        image: javascript
    },
    {
        name: 'REACT JS',
        image: react
    },
    {
        name: 'REDUX',
        image: redux
    },
    {
        name: 'NODE JS',
        image: node
    },
    {
        name: 'MongoDB',
        image: mongo
    },
    {
        name: 'FIREBASE',
        image: firebase
    },
    {
        name: 'MySQL',
        image: mysql
    },
    {
        name: 'AWS',
        image: aws
    },
    {
        name: 'GITHUB',
        image: github
    }
]

export default SkillData;